import React from 'react';


export default class SmsData extends React.Component {
    render() {
        const sms = this.props;
        const convertDateTimeFormat = (dateTime) => {
            // Разбиваем исходную строку на дату и время
            const [datePart, timePart] = dateTime.split('T');
          
            // Разбиваем части даты и времени на компоненты
            const [year, month, day] = datePart.split('-');
            const [time, _] = timePart.split('.');
          
            // Форматируем время
            const formattedTime = time.slice(0, 8); // Обрезаем миллисекунды
          
            // Собираем новую строку в нужном формате
            const formattedDateTime = `${day}.${month}.${year} ${formattedTime}`;
          
            return formattedDateTime;
          }
        return (
            <li className="flex justify-between gap-x-6 py-5">
                <div className="flex gap-x-4">
                <div className="min-w-0 flex-auto">
                    <p className="text-sm font-semibold leading-6 text-gray-900">From: {sms.item.phone_from}</p>
                    <p className="text-sm font-semibold leading-6 text-gray-900">TO: {sms.item.phone_to}</p>
                    <p className="mt-1 truncate text-xs leading-5 text-gray-500">{sms.item.message}</p>
                </div>
                </div>
                <div className="hidden sm:flex sm:flex-col sm:items-end">
                    <p className="text-sm leading-6 text-gray-900">{convertDateTimeFormat(sms.item.ctime)}</p>
                </div>
            </li>
        )
    }
}